import React, { useContext } from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';

import Box from '../../../elements/Box';
import Text from '../../../elements/Text';

const FareItemCarType = (props) => {
  const { vehicleClass, vehicleClassStyle, vehicleType, vehicleTypeStyle, id } = props;
  const { translate, direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });

  return (
    <Box className={`fare-car-class-type ${className}`} style={style} id={id}>
      <Text {...vehicleClassStyle}>{translate(`cmp-car-class-${vehicleClass}`, vehicleClass)}</Text>
      <Text {...vehicleTypeStyle}>{translate(`cmp-car-type-${vehicleType}`, vehicleType)}</Text>
    </Box>
  );
};

FareItemCarType.defaultProps = {
  vehicleClass: '',
  vehicleClassStyle: {},
  vehicleType: '',
  vehicleTypeStyle: {}
};

FareItemCarType.componentName = 'FareItemCarType';

export default FareItemCarType;
